import React from 'react'
import PropTypes from 'prop-types'

import { Table } from '../../..'

const tableDisplay = [
    {
        field: 'id',
        label: 'ID',
        props: null,
        transform: null,
        width: '50px',
    },
    {
        field: 'name',
        label: 'Name',
        props: null,
        transform: null,
        width: '300px',
    },
]

const Channels = ({ data, onChangeSearch, valueSearch }) => (
    <Table data={data} display={tableDisplay} keyField="id" onChangeSearch={onChangeSearch} sortable title="Channels" valueSearch={valueSearch} />
)

Channels.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            status: PropTypes.string,
            playlists: PropTypes.number,
            media: PropTypes.number,
        })
    ),
    onChangeSearch: PropTypes.func,
    valueSearch: PropTypes.string,
}

Channels.defaultProps = {
    data: [],
    onChangeSearch: () => null,
    valueSearch: '',
}

export default Channels
